import { useCallback, useState } from 'react';

export const useToggleDrawer = () => {
  const [open, setOpen] = useState(false);

  const openDrawer = useCallback(() => {
    setOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setOpen(false);
  }, []);

  const toggleDrawer = useCallback(() => {
    setOpen((open) => !open);
  }, []);

  return {
    open,
    openDrawer,
    closeDrawer,
    toggleDrawer,
  };
};

export default useToggleDrawer;
